//global variables
/* eslint-disable */
declare var siteUrl: string;
declare var isDebug: boolean;

var aptUtils: any = aptUtils || {};
aptUtils = (function ($: JQueryStatic) {
	const layoutLocations = "top-left top-center top-right center-left center center-right bottom-left bottom-center bottom-right";

	/* eslint-enable */
	const _onFormFailed = function (data: AjaxReturnData) {
		console.log("HTTP Status Code: " + data.status + "  Error Message: " + data.error);
		window.location.href = siteUrl.concat("/SM/Account/Index");
	}

	/**
	 * Override console.log() to disable logging in production
	 * @param {boolean} isDebug Flag true/false
	 */
	if (!isDebug) {
		(function () {
			let method: string;
			const noop = function noop() { return };
			const methods: string[] = [
				"assert", "clear", "count", "debug", "dir", "dirxml",
				"exception", "group", "groupCollapsed", "groupEnd",
				"markTimeline", "profile", "profileEnd", "table", "time", "timeEnd",
				"timeStamp", "trace"
			];
			let length: number = methods.length;
			const w: any = window;
			const console: any = w.console = w.console || {};

			while (length--) {
				method = methods[length];
				console[method] = noop;
			}
			console.log("noop");
		}());
	}

	const _showResults = function (messages: message[]) {
		$("#results").empty();

		if (messages !== null) {
			for (const msg of messages) {
				console.log(msg);
				switch (msg.item2) {
					case "error":
						$("#results").append("<p class='text-danger'>" + msg.item1 + "</p>");
						break;
					case "info":
						$("#results").append("<p class='text-info'>" + msg.item1 + "</p>");
						break;
					case "":
					default:
						$("#results").append("<p>" + msg.item1 + "</p>");
						break;
				}
			}
		}
	}

	/** Custom warning dialog for participants 
	 * @param {string} title title of message
	 * @param {string} message message to participant
	 * @param {number?} countdownSeconds counter to end session (if applicable)
	 */
	const _showModalDialog = function (title: string, message: string, countdownSeconds?: number) {
		let _countdownModal: number
		$("#smModalTitle").html(title)
		$("#smModalMessage").html(message)

		try {
			$("#sm-modal-dialog").modal("show")
		} catch (e) {
			let modal = new bootstrap.Modal('#sm-modal-dialog')
			modal!.show()
		}
		
		$("#sm-modal-dialog").on("hidden.bs.modal", () => {
			$("#smModalTitle, #smModalMessage").empty() //clear former message
			clearTimeout(_countdownModal)
		})

		if (countdownSeconds && countdownSeconds > 0) {
			_countdownModal = window.setTimeout(function () {
				// Call self after x seconds
				if ($("#sm-modal-dialog").is(":visible")) { //modal dialog still shown
					window.location.href = siteUrl.concat("/Logon/Exit?401")
				}
			}, (countdownSeconds * 1000))
		}
	}

	const _showFullscreenModal = function(title: string, message: string) {
		$('#smModalFullscreenTitle').html(title)
		$('#smModalFullscreenBody').html(message)
		$("#smModalFullscreen").on("hidden.bs.modal", () => {
			$("#smModalFullscreenTitle, #smModalFullscreenBody").empty()
		})
	}

	const _confirmationModal = function (title: string, message: string, confirmFunction: () => void, OKText: string, cancelText: string) {
		$("#confirmButtons").prop("hidden", "");
		$("#confirm").on("click", confirmFunction);
		$("#confirm").html(OKText);
		$("#cancel").html(cancelText);
		_showModalDialog(title, message);
	}

	/** Return and toggle the value of the "is locked" property of the specified object.
	 *  Initial purpose is to prevent the infamous double-click of a button, link, etc.
	 * @param {LockObject} lockObject Object containing isLocked property (default set in constructor)
	 * @param {number} lockTime Amount of time in milliseconds to return isLocked property to false.
	 */
	const _isLocked = function (lockObj: LockObject, lockTime: number) {
		if (lockObj.isLocked)
			return true;
		else {
			lockObj.isLocked = true;
			setTimeout(function () { lockObj.isLocked = false; }, lockTime);
			return false;
		}
	}

	function _changeLayoutPosition(position: string) {
		$("#layoutLocation").show();
		if (position !== undefined) {
			if (position === "close") {
				$("#layoutLocation").hide();
			}
			else {
				$("#survey")
					.removeClass(layoutLocations)
					.addClass(position);
			}
		}
	}

	let externalLinkPopup: Window | null;
	function _openExternalLinkPopup(url: string, title: string, settings: string) {
		if (externalLinkPopup !== null || externalLinkPopup !== undefined) {
			externalLinkPopup?.focus();
		}
		externalLinkPopup = window.open(url, title, settings);
	}

	let editWindow: any;
	function _openEditWindow() {
		if (editWindow !== null && editWindow !== undefined) {
			if (!editWindow.closed) {
				editWindow.focus();
				return;
			}
		}
		editWindow = window.open(siteUrl + '/EditContent/Editor/StartEdit', '_contentEditor', 'popup, width=1000, height=750');
		$(document).on('click', '#next, #previous', () => { editWindow?.location.reload() });
	}

	return {
		/** Server message display
		* @param {message[]} messages Array of messages { message text, message type }
		*/
		showResults: _showResults,
		onFormFailed: _onFormFailed,
		logoff: () => { window.location.href = siteUrl.concat("/Logon/Logoff"); },
		/**
		* Check browser support for cookies. Redirect to "Cookies Required" page if not enabled.
		*/
		cookiesCheck: (url: string) => { if (!navigator.cookieEnabled) window.location.href = url },
		showModalDialog: _showModalDialog,
		showFullscreenModal: _showFullscreenModal,
		confirmationModal: _confirmationModal,
		isLocked: _isLocked,
		changeLayoutPosition: _changeLayoutPosition,
		openExternalLinkPopup: _openExternalLinkPopup,
		openEditWindow: _openEditWindow,
		prefersReducedMotion: window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true
	}
})($);

interface JsonData {
	success: boolean;
	messages: Array<message>;
	message: string;
	url: string;
}

interface AjaxReturnData {
	xhr?: JQueryXHR;
	status?: string;
	error?: string;
	data?: any;
}

class LockObject {
	public isLocked: boolean;
	constructor(locked: boolean) {
		this.isLocked = locked;
	}
}

type message = { item1: string; item2?: string };
